import { apiRequest } from "../util/apiUtils";

export const quizList = async (params) => {
  try {
    const res = await apiRequest("get", `quiz/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const quizDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `/quiz/backend/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const quizAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `quiz/backend/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const quizDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `quiz/backend/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const quizStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `quiz/backend/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};